import styled from "@emotion/styled";

export const PopoverRoot = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.75rem;
  max-width: 19.25rem;
`;
